import React from 'react';
import { FadeIn } from './FadeIn';
export function ScienceSection() {
  const coverUrl = 'https://cdn.magicpatterns.com/uploads/gKUFq959Y73zKV8vJ7SPih/ChatGPT_Image_7_jun_2026,_10_42_20_a.m..png';
  const scienceFacts = [{
    emoji: '🔬',
    text: 'Un programa estructurado de MBSR de 8 semanas mostró eficacia comparable a escitalopram en un ensayo clínico sobre trastornos de ansiedad (Hoge et al., JAMA Psychiatry, 2022)'
  }, {
    emoji: '🏃',
    text: 'El ejercicio reduce ansiedad con efecto g = -0.42 (Singh et al., BJSM, 2023)'
  }, {
    emoji: '🌬️',
    text: 'El suspiro fisiológico mostró beneficios en estado de ánimo y frecuencia respiratoria con 5 min/día (Balban et al., Cell Reports Medicine, 2023)'
  }];
  return <section className="py-20 bg-white" data-id="element-170" data-mp="3ty5lfwp9wbic">
      <div className="max-w-6xl mx-auto px-6" data-id="element-171" data-mp="3txcjra568c72">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-172" data-mp="2runwajh1svr">
          {/* Left Side - Image */}
          <div className="w-full md:w-1/2" data-id="element-173" data-mp="g9wogxl5khnj">
            <FadeIn direction="right" data-id="element-174" data-mp="g8veyxjsc37x">
              <div className="relative w-full max-w-md mx-auto aspect-[3/5]" data-id="element-175" data-mp="baa9ailrkrc3">
                <div className="absolute inset-0 bg-brand-forest opacity-10 rounded-3xl transform -translate-x-4 translate-y-4" data-id="element-176" data-mp="bcd9fvgms0uj"></div>
                <img src={coverUrl} alt="Mujer meditando en la naturaleza con representación de claridad mental" className="relative z-10 w-full h-full object-cover rounded-2xl shadow-xl" data-id="element-177" data-mp="2ii4anfieaew" />
              </div>
            </FadeIn>
          </div>

          {/* Right Side - Content */}
          <div className="w-full md:w-1/2" data-id="element-178" data-mp="3jqdjav0cms3l">
            <FadeIn data-id="element-179" data-mp="3fp0cahlisiv3">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-forest mb-6" data-id="element-180" data-mp="3fpjv00izvba6">
                No es autoayuda.
                <br data-id="element-181" data-mp="1hxxoo1csont7" />
                Es ciencia aplicada.
              </h2>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-182" data-mp="1dxwyjjgc2o6b">
              <div className="text-brand-charcoal space-y-4 mb-8 leading-relaxed" data-id="element-183" data-mp="37g4ddxmmydck">
                <p data-id="element-184" data-mp="37e1cujnux1tl">
                  Cada módulo de esta guía está respaldado por estudios
                  publicados en revistas científicas internacionales.
                </p>
                <p data-id="element-185" data-mp="2yh0qeikcldss">
                  El meta-análisis más grande de la historia del ejercicio y
                  salud mental (Singh et al., British Journal of Sports
                  Medicine, 2023 — 128.119 participantes). Una amplia revisión
                  de estudios encontró beneficios significativos de la actividad
                  física sobre síntomas de depresión, ansiedad y distrés
                  psicológico.
                </p>
                <p data-id="element-186" data-mp="3m3z8fko48tst">
                  Un estudio de Stanford (Balban et al., Cell Reports Medicine,
                  2023) encontró que 5 minutos diarios de respiración
                  estructurada pueden mejorar el estado de ánimo y reducir la
                  activación fisiológica.
                </p>
                <p className="font-semibold text-brand-forest" data-id="element-187" data-mp="227jprhllcyd3">
                  Todo esto — y más — está en tus manos en formato práctico y
                  aplicable desde hoy.
                </p>
              </div>
            </FadeIn>

            <div className="space-y-4" data-id="element-188" data-mp="2c4oare3pansb">
              {scienceFacts.map((fact, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-189" data-mp="275l6vwzginlx" data-mpi={index}>
                  <div className="bg-brand-sage bg-opacity-10 border border-brand-sage border-opacity-20 p-4 rounded-xl flex items-start gap-3 hover:bg-opacity-20 transition-colors duration-300" data-id="element-190" data-mp="1jj4xkqzjfeap">
                    <span className="text-xl flex-shrink-0 mt-0.5" data-id="element-191" data-mp="1t8y7zony1ndd">
                      {fact.emoji}
                    </span>
                    <p className="text-sm font-medium text-brand-forest leading-snug" data-id="element-192" data-mp="1ofvefgj62dx6">
                      {fact.text}
                    </p>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}